export default __webpack_public_path__ + "static/media/vip4_right.7e1df8eb.webp";